import script from "./page-form.vue?vue&type=script&setup=true&lang=js"
export * from "./page-form.vue?vue&type=script&setup=true&lang=js"

import "./page-form.vue?vue&type=style&index=0&id=bd5a4aee&scoped=true&lang=css"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd5a4aee"]])

export default __exports__